import React from 'react';
import { createRoot } from 'react-dom/client';
import Container from '../../src/account_newsletters/container';
import { UAContextProvider } from '../../src/account_newsletters/context/ua_context';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
// Styles
import '../../src/account_newsletters/styles/main.scss';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('ua-newsletters-react-app');

  if (!container) return;

  const root = createRoot(container);

  root.render(
    <DevexHighOrderComponent>
      <UAContextProvider
        emailFromUrl={JSON.parse(container.dataset.emailFromUrl)}
      >
        <Container isSignedIn={false} formerProUser={false} />
      </UAContextProvider>
    </DevexHighOrderComponent>
  );
});
